import { replaceAllSpecialCharacter } from './text'
import { getTrackingFormattedSlug } from './urls'

window.dataLayer = window.dataLayer || []
if (!window.trackings) {
  window.trackings = {}
}

//* Cast the HTML Element to an object and get the dataset value
export const getDatasetFromHTMLElement = (htmlElement: HTMLElement) => ({ htmlElement }).htmlElement.dataset

export const pushGTMFormattedDataLayerWithSlug = (event: string, suppl: string | undefined = undefined) => {
  const formattedSuppl = suppl ? `-${suppl.replace(/-/g, '_')}` : ''

  return window?.dataLayer?.push({ event: `${event}|${getTrackingFormattedSlug()}${formattedSuppl}` })
}

export const pushGTMFormattedDataLayer = (
  event: string,
  isUnique = false,
  otherParams: Record<string, string | undefined> = {},
) => {
  const eventFormatted = event.split('|').map(replaceAllSpecialCharacter).join('|')

  if (isUnique && window?.dataLayer.find((dataLayer: { event: string }) => dataLayer?.event === eventFormatted)) {
    return
  }

  if (process.env.DEBUG_GTM === 'true') {
    console.log(`GTM TRIGGER: ${eventFormatted}`)
  }

  return window.dataLayer.push({ event: eventFormatted, ...otherParams })
}
